<template>
    <div>
    <!-- <app-header></app-header> -->
    <div class="l-container contact">
        <div class="l-contact">
            <strong class="tit">Error</strong>
            <div id="map" class="map"></div>
            <div class="l-pc">
                <div class="address">
                    <strong>요청하신 페이지를 찾을 수 없습니다.</strong>
                    <p>해당 페이지는 경로가 변경되었거나, 서버에 존재하지 않습니다.<br />파일의 경로가 정확한지, URL 주소를 바르게 입력했는지 확인해주세요.</p>
                    <br/>
                    <a href="https://www.xeogen.com">Go XEOGEN Main Click</a>                 
                </div>
            </div>
        </div>
    </div>  
    <!-- <app-footer></app-footer> -->
    </div>   
</template>
<script>
// import Header from './Header.vue';
// import Footer from './Footer.vue';
export default {
   name: 'App',
   data(){
       return{
            currentRoute: window.location.pathname  
       }
   },
   mounted: function(){
        
   },
    methods:{
       
    },
    components: {
    //    'app-header': Header,
    //    'app-footer': Footer
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Error.vue